<template>
  <modal :show-on-mount="true" :click-outside-to-close="false" :headerless="true" size="sm"
         modal-id="moderate-on-publish-modal">
    <template #sub-heading>
      <h3 class="m-0 pt-4 pb-1 d-flex justify-content-center">
        {{ title }}
      </h3>
    </template>

    <template #body>
      <span>{{ i18n.t(`${localizedStringsPrefix}.moderate_on_publish_explanation`) }}</span>

      <radio-buttons-with-hints input-name="post-publish-options" :options="onPublishOptions" class="mt-4"
                                :initial-value="selectedOption" :validation-errors="validationErrors"
                                @change="(v) => selectedOption = v" />

      <primary-button :label="i18n.t('administrative.continue')" class="w-100 mt-4" @click="continueWithSelectedOption" />
    </template>
  </modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/modal'
import PrimaryButton from '@/components/buttons/primary-button'
import RadioButtonsWithHints from '@/components/inputs/radio-buttons-with-hints'

export default {
  components: { Modal, PrimaryButton, RadioButtonsWithHints },

  props: {
    localizedStringsPrefix: {
      type: String,
      required: true
    }
  },

  emits: ['continue'],

  data() {
    return {
      selectedOption: null,
      validationErrors: []
    }
  },

  computed: {
    ...mapState(['campaignAwaitingApproval']),

    onPublishOptions() {
      return [
        {
          value: 'automatically_approve',
          name: this.i18n.t(`${this.localizedStringsPrefix}.automatically_approve_label`),
          hint: this.i18n.t(`${this.localizedStringsPrefix}.automatically_approve_hint`)
        },
        {
          value: 'send_to_moderation',
          name: this.i18n.t(`${this.localizedStringsPrefix}.send_to_moderation_label`),
          hint: this.i18n.t(`${this.localizedStringsPrefix}.send_to_moderation_hint`)
        }
      ]
    },

    title() {
      return this.i18n.t(`${this.localizedStringsPrefix}.instantly_approve`)
    }
  },

  methods: {
    ...mapActions(['moderateWithOneClickAndRedirect', 'redirect']),

    continueWithSelectedOption() {
      if (!this.selectedOption) {
        this.validationErrors = [this.i18n.t(`${this.localizedStringsPrefix}.must_select_an_option_error`)]
        return
      }

      this.validationErrors = []

      switch (this.selectedOption) {
      case 'automatically_approve':
        this.moderateWithOneClickAndRedirect()
        break
      case 'send_to_moderation':
        this.continueWithoutModerating()
        break
      }
    },

    continueWithoutModerating() {
      // Display the modal if the camaign is awaiting approval, otherwise redirect
      if (this.campaignAwaitingApproval) {
        this.$store.commit('setDisplayModerateOnPublishModal', false)
        this.$store.commit('setDisplayAwaitingApprovalModal', true)
      } else {
        this.redirect()
      }
    }
  }
}
</script>
